var _rect, _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 56,
    viewBox: "0 0 128 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2740_52157",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 128,
    height: 56
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 56,
    fill: "url(#paint0_linear_2740_52157)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2740_52157)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M128 17.1982C126.711 17.0957 125.42 17.0413 124.128 17.0413C114.19 17.0413 104.341 20.2603 94.4738 23.4849C87.8664 25.6443 81.2512 27.8063 74.5961 29.006C58.0029 31.9971 41.6573 29.006 25.0641 18.5369C19.8295 15.2343 14.6195 11.1874 9.41864 7.14766C6.27692 4.70732 3.13851 2.26957 0 0V56H128V17.1982Z",
    fill: "#D92D20"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M0 29.3468V56H128V34.3499C123.889 36.2625 119.788 38.1213 115.687 39.4759C104.667 43.1159 93.6467 43.1159 82.6267 38.7479C77.1167 36.5639 71.5583 33.2879 66 30.0119C60.4417 26.736 54.8833 23.46 49.3733 21.276C38.3533 16.908 27.3333 16.908 16.3133 21.276C12.6684 22.7207 9.02338 24.6434 5.37142 26.5697C3.5829 27.5131 1.7927 28.4573 0 29.3468Z",
    fill: "#D92D20"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2740_52157",
    x1: 64,
    y1: 0,
    x2: 64,
    y2: 56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedChart);
export default __webpack_public_path__ + "static/media/redChart.517db5c4d967828360135323ce331d7f.svg";
export { ForwardRef as ReactComponent };